import React, { forwardRef } from 'react'
import { THEME_DARK } from 'constants.js'
import DarkInput from './DarkInput'
import LightInput from './LightInput'
import { SimpleInputProps } from './types'

const SimpleInput = ({ themeColor, ...props }: SimpleInputProps, ref) => {
    return themeColor === THEME_DARK ? <DarkInput {...props} ref={ref} /> : <LightInput {...props} ref={ref} />
}

export default React.memo(forwardRef(SimpleInput))
